import { render, staticRenderFns } from "./ProjectGantt.vue?vue&type=template&id=80f996e6"
import script from "./ProjectGantt.vue?vue&type=script&lang=js"
export * from "./ProjectGantt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports